type Props = {
	title: string;
	subtitle: string;
	percentage: number;
	showSavedBadge?: boolean;
};

const ProgressSection = ({ title, subtitle, percentage, showSavedBadge = true }: Props) => {
	return (
		<div className="px-4 pt-4 pb-2 bg-white">
			<div className="flex items-center gap-3">
				<h2 className="text-xl font-semibold text-gray-900">{title}</h2>

				{showSavedBadge && (
					<span className="text-xs font-medium text-green-700 bg-green-100 px-2 py-1 rounded-full">
						Progress Saved
					</span>
				)}
			</div>

			<p className="text-sm text-gray-600 mt-1">{subtitle}</p>

			<div className="w-full bg-gray-200 h-2 rounded-full mt-3 overflow-hidden">
				<div className="h-full bg-indigo-600 transition-all duration-500" style={{ width: `${percentage}%` }} />
			</div>
		</div>
	);
};

export default ProgressSection;

